/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine           **
** ----------------------------------------------- **
**  Copyright (c) 2020-2025 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
*                                                 */

// Vertex shader for swirl transition. It computes UV coordinates from
// clip‑space positions, similar to other transition shaders.

export default function vs() {
  return `
  attribute vec2 aPosition;
  varying vec2 vUV;
  void main() {
      vUV = (aPosition + 1.0) * 0.5;
      gl_Position = vec4(aPosition, 0.0, 1.0);
  }
  `;
}